import { withFeatureBranch } from '@wix/da-shared-react/pkg/redux/flags';
import { default as ZoneV1 } from './Zone.connected';
import { default as ZoneV2 } from '../ZoneV2';
const Zone = withFeatureBranch({
  eclipse_core_custombox: ZoneV2,
})(ZoneV1 as any);

import { default as ZoneGroupV1 } from './ZoneGroup';
import { default as ZoneGroupV2 } from '../ZoneV2/ZoneGroup';
const ZoneGroup = withFeatureBranch({
  eclipse_core_custombox: ZoneGroupV2,
})(ZoneGroupV1 as any);

export default Zone;
export { Zone, ZoneGroup };
